import { useEffect, useState } from 'react'
import toast, { Toaster } from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'

import { translations } from '../../configs/translations'
import { RaceTypes } from '../../enums/RaceTypes'
import { VehicleService } from '../../services/VehicleService'
import { useStore } from '../../store/store'
import { VehicleResearchResponse } from '../../types/vehicle'

import { Header } from '../main/header/Header'
import './Research.css'

import { UserProfile } from '../../models/UserProfile'
import { ResearchTreeBranchBar } from './researchTree/leftBar/ResearchTreeBranchBar'
import { ResearchTree } from './researchTree/ResearchTree'

export type BRANCHES = 'GERMAN' | 'JAPANESE' | 'SOVIET'

export const Research = () => {
  const [userProfile, setUserProfile] = useState<UserProfile | null>(JSON.parse(localStorage.getItem('profile') || 'null'))
  const language = useStore((state) => state.language) as keyof typeof translations
  const t = translations[language]

  const navigate = useNavigate()

  const [data, setData] = useState<VehicleResearchResponse[]>([])
  const userId = useStore((state) => state.userId) || 0

  const [branch, setBranch] = useState<BRANCHES>('GERMAN')
  const [triggerUpdate, setTriggerUpdate] = useState(0)

  useEffect(() => {
    const fetchData = async () => {
      await VehicleService.fetchResearchTree(userId, branch)
        .then((data) => {
          setData(data)
          setUserProfile(null)
        })
        .catch((error) => {
          toast.error(
            error?.response?.data && t[error.response.data as keyof typeof t]
              ? t[error.response.data as keyof typeof t]
              : t.error_unknown,
            { className: 'notification-error' }
          )
        })
    }

    fetchData()
  }, [branch, triggerUpdate, userId, t])

  const getHeaderText = () => {
    switch (branch) {
      case 'GERMAN':
        return t.german_cars
      case 'JAPANESE':
        return t.japanese_cars
      case 'SOVIET':
        return t.soviet_cars
    }
  }

  return (
    <div>
      <Header
        profile={userProfile}
        setProfile={setUserProfile}
        selectedMode={RaceTypes.RANKED}
        selectedVehicle={null}
        title={t.research}
      />

      <div className="research-tree-content-zone">
        <div className="research-tree-main-header">
          <div className="research-tree-cars-main-header-title">
            <h1>{getHeaderText()}</h1>
          </div>
        </div>

        <ResearchTreeBranchBar branch={branch} setBranch={setBranch} />

        <ResearchTree
          data={data}
          setTriggerUpdate={setTriggerUpdate}
          navigate={navigate}
        />

        <Toaster toastOptions={{ duration: 2000, position: 'bottom-center' }} />

        <div className="research-tree-background">
          <img
            src="/research/research-tree-background.webp"
            alt="research-tree-background"
          />
        </div>
      </div>
    </div>
  )
}